// import { openModal } from "./_modal.js";

// var actionButton = document.querySelector(".hero__button");
// var gameIntro = document.querySelector(".hero__game-intro");
// var gameForm = document.querySelector(".hero__game");
// var form = document.querySelector(".hero__form");
// var scScore = document.querySelector("#scScore");
// var visitorScore = document.querySelector("#visitorScore");
// var twitterButtonContainer = document.querySelector(".hero__twitter");
// var twitterButton = document.querySelector(".hero__twitter-btn");
// var heroActions = document.querySelector(`.hero__actions`);
// var heroSteps = document.querySelector(".hero__stepper");
// var heroShout = document.querySelector(".hero__finish");
// var heroStep = document.querySelectorAll(".hero__step");
// var heroDot = document.querySelectorAll(".hero__icon");
// var heroDirections = document.querySelector(".hero__directions");
// var heroInputWrapH = document.querySelector(".hero__input-wrapper--home");
// var heroInputWrapA = document.querySelector(".hero__input-wrapper--away");
// var heroLabelH = document.querySelector(".hero__label--home");
// var heroLabelA = document.querySelector(".hero__label--away");
// var finishCheck = document.querySelector(".hero__finish-img");
// var shape = document.querySelector(".hero__shape");
// var shapeWrapper = document.querySelector(".hero__shape-wrapper");
// var heroFooter = document.querySelector(".hero__footer");
// var submitModal = document.querySelector("#submit");
// var inputs = document.querySelectorAll(".hero__input");
// var stepperText1 = document.querySelector("#step-1");
// var stepperIcon = document.querySelector("#icon-step-1");

// //Starts the game and hides the intro
// actionButton.addEventListener("click", function() {
//     alert("Sorry, this contest is no longer avaliable. Please check back at a later date");
//     // if (this.dataset.nextStep == undefined) {
//     //     heroSteps.setAttribute("data-current-step", 1);
//     //     gameIntro.setAttribute("data-is-visible", "false");
//     //     gameForm.setAttribute("data-is-visible", "true");
//     //     heroSteps.setAttribute("data-current-step", 1);
//     //     heroActions.setAttribute("data-current-step", 1);
//     //     actionButton.innerText = "Next";
//     //     actionButton.dataset.nextStep = 2;
//     //     actionButton.disabled = true;
//     // } else {
//     //     nextStep(this.dataset.nextStep);
//     // }
// });

// visitorScore.addEventListener("keyup", function() {
//     toggleButtonAvailability();
// });

// scScore.addEventListener("keyup", function() {
//     toggleButtonAvailability();
// });

// // Enables the next button
// function toggleButtonAvailability() {
//     if (scScore.value !== "" && visitorScore.value !== "") actionButton.disabled = false;
//     else actionButton.disabled = true;
// }

// /* No longer required - leaving commented just in case
// function showStep(next) {
//     var step = document.getElementsByClassName("hero__content--step");
//     step[currentTab].style.display = "block";
// }*/

// // Builds the tweet button and displays it during step 2
// function updateTweet() {
//     let visitor = heroLabelA.innerText;
//     let tweetText = ``;

//     // Customize message based on users input
//     if (scScore.value >= visitorScore.value) {
//         tweetText = `I predict the score will be Gamecocks - ${scScore.value}, ${visitor} - ${visitorScore.value} for the @ColonialLife #UnexpectedMoment challenge at ColonialLife.com/UofSC!`;
//     } else {
//         tweetText = `I predict the score will be ${visitor} - ${visitorScore.value}, Gamecocks - ${scScore.value} for the @ColonialLife #UnexpectedMoment challenge at ColonialLife.com/UofSC!`;
//     }
//     let encodedText = encodeURIComponent(tweetText.trim());

//     twitterButton.href = `https://twitter.com/intent/tweet?text=${encodedText}`;
//     twitterButtonContainer.setAttribute("data-is-visible", "true");
//     scScore.disabled = true;
//     visitorScore.disabled = true;
//     twitterButton.addEventListener("click", function(e) {
//         nextStep("3");
//     });
// }

// // Helper that shows the modal in the hero after step 2
// /* function showModal(modal) {
//     document.body.setAttribute("data-modal-open", "true");
//     modal.setAttribute("data-modal-open", "true");
// }*/

// // Controls and validates the modal that displays between step 1 and 2 in the game
// function handleIFrameSubmission() {
//     let submit = document.getElementById("emailSignup").contentWindow.document.getElementById("submitEmail");
//     let input = document.getElementById("emailSignup").contentWindow.document.getElementById("control_EMAIL");

//     submit.disabled = true;
//     submit.addEventListener(
//         "click",
//         function() {
//             let modal = document.querySelector(".modal[data-modal-open='true']");
//             modal.setAttribute("data-modal-open", "false");
//             document.body.setAttribute("data-modal-open", "false");
//             modal.querySelector("iframe").style.display = "none";
//             localStorage.setItem("emailSubmitted", "true");
//         },
//         false
//     );

//     input.addEventListener("keyup", function() {
//         if (this.value.length > 3 && this.value.indexOf("@") != "-1" && this.value.indexOf(".") != "-1")
//             submit.disabled = false;
//         else submit.disabled = true;
//     });
// }

// // Workaround for remove event listener
// var stepBack = function() {
//     nextStep("1");
// };

// function nextStep(next) {
//     switch (next) {
//         case "1":
//             // Disables step back
//             stepperText1.removeEventListener("click", stepBack);
//             stepperText1.setAttribute("data-current-step", 1);
//             stepperIcon.removeEventListener("click", stepBack);
//             stepperIcon.setAttribute("data-current-step", 1);

//             // Build step 1
//             // (this is should only be required for stepping back...we may want to look into simplyfying
//             // how we build steps throughout the game)
//             actionButton.dataset.nextStep = 2;
//             actionButton.setAttribute("data-is-visible", "false");
//             heroDirections.innerHTML = "Enter score in the boxes below";
//             heroDirections.setAttribute("data-current-step", 1);
//             heroSteps.setAttribute("data-current-step", 1);
//             heroInputWrapH.setAttribute("data-current-step", 1);
//             heroInputWrapA.setAttribute("data-current-step", 1);
//             scScore.setAttribute("data-current-step", 1);
//             visitorScore.setAttribute("data-current-step", 1);
//             heroLabelH.setAttribute("data-current-step", 1);
//             heroLabelA.setAttribute("data-current-step", 1);
//             form.setAttribute("data-current-step", 1);
//             heroActions.setAttribute("data-current-step", 1);
//             shape.setAttribute("data-current-step", 1);
//             shapeWrapper.setAttribute("data-current-step", 1);
//             heroFooter.setAttribute("data-current-step", 1);

//             // Disables game intro and shows the game
//             gameIntro.setAttribute("data-is-visible", "false");
//             gameForm.setAttribute("data-is-visible", "true");

//             // Disables components from step 2 and disables the action button until scores are input
//             twitterButtonContainer.setAttribute("data-is-visible", "false");
//             scScore.disabled = false;
//             visitorScore.disabled = false;
//             //actionButton.disabled = true;

//             // Resets text on the actionButton
//             actionButton.setAttribute("data-is-visible", "true");
//             actionButton.innerText = "Next";

//             // Set the next step to 2
//             actionButton.dataset.nextStep = 2;
//             break;
//         case "2":
//             // Enable step back
//             stepperText1.addEventListener("click", stepBack);
//             stepperText1.setAttribute("data-current-step", 2);
//             stepperIcon.addEventListener("click", stepBack);
//             stepperIcon.setAttribute("data-current-step", 2);

//             // Build step 2
//             updateTweet();
//             heroDirections.innerHTML =
//                 "Tweet to enter and win! <p class='hero__directions-subheading'>(Limit: 1 entry per Twitter account per game)</p>";
//             heroDirections.setAttribute("data-current-step", 2);
//             heroSteps.setAttribute("data-current-step", 2);
//             heroInputWrapH.setAttribute("data-current-step", 2);
//             heroInputWrapA.setAttribute("data-current-step", 2);
//             scScore.setAttribute("data-current-step", 2);
//             visitorScore.setAttribute("data-current-step", 2);
//             heroLabelH.setAttribute("data-current-step", 2);
//             heroLabelA.setAttribute("data-current-step", 2);
//             form.setAttribute("data-current-step", 2);
//             heroActions.setAttribute("data-current-step", 2);
//             shape.setAttribute("data-current-step", 2);
//             shapeWrapper.setAttribute("data-current-step", 2);
//             heroFooter.setAttribute("data-current-step", 2);

//             // Hide next button
//             actionButton.setAttribute("data-is-visible", "false");

//             // Pop the email modal
//             if (localStorage.getItem("emailSubmitted") !== "true") {
//                 handleIFrameSubmission();
//                 // openModal(submitModal); Disabled for Alabama game
//             }

//             // Set the next step to 3
//             actionButton.dataset.nextStep = 3;
//             break;
//         case "3":
//             // Diable step back
//             stepperText1.removeEventListener("click", stepBack);
//             stepperText1.setAttribute("data-current-step", 3);
//             stepperIcon.removeEventListener("click", stepBack);
//             stepperIcon.setAttribute("data-current-step", 3);

//             // Hide form, directions and tweet button
//             form.setAttribute("data-is-visible", "false");
//             twitterButtonContainer.setAttribute("data-is-visible", "false");
//             heroDirections.dataset.isVisible = false;

//             // Show the icon that indicates the game is complete
//             finishCheck.setAttribute("data-is-visible", "true");

//             // Build step 3
//             heroShout.setAttribute("data-current-step", 3);
//             heroSteps.setAttribute("data-current-step", 3);
//             shape.setAttribute("data-current-step", 3);
//             heroActions.setAttribute("data-current-step", 3);
//             heroFooter.setAttribute("data-current-step", 3);
//             break;
//         default:
//             break;
//     }
// }
